// ---
import { categories } from '../utils/constants';

const selectedCategory = 'New';

const Sidebar = ({ selectedCategory, setSelectedCategory }) => {
  return (
    <section className='px-2.5 md:px-0 flex flex-row lg:flex-col overflow-x-scroll'>
      {categories.map((category) => (
        <button
          onClick={() => setSelectedCategory(category.name)}
          className={`mb-2 px-4 py-2 flex items-center justify-start text-white rounded-full ${category.name === selectedCategory ? 'bg-red-600' : 'bg-transparent hover:bg-gray-900'}`}
          key={category.name}
        >
          <span className={`mr-4 ${category.name === selectedCategory ? 'text-white' : 'text-red-600'}`}>{category.icon}</span>
          <span>{category.name}</span>
        </button>
      ))}
    </section>
  );
};

export default Sidebar;
